import '../Styles/Navbar.css';

import { Link } from "react-router-dom"

import { useState } from 'react';

import Timeout from "./Timeout";

export function Navbar() {
    const [masterdata, setMasterData] = useState({});

    //const setMasterDataState = (data) => {setMasterData(data)};

    return (
        <div className="navbar">
            <Timeout/>
        </div>
    )
}